import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class LVPNBlock extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: {
                client: false,
                tap: false,
                doc_client: false
            }
        }
        this.onClickLVPNDownload = this.onClickLVPNDownload.bind(this);
        this.onClickGetVPNClientFile = this.onClickGetVPNClientFile.bind(this);
    }

    onClickLVPNDownload(e, system) {
        this.setState({
            isLoading: {
                ...this.state.isLoading,
                [system]: true
            }
        })
        this.props.onClickLVPNDownload(e).then(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        }).catch(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        })
    }

    onClickGetVPNClientFile(system) {
        this.setState({
            isLoading: {
                ...this.state.isLoading,
                [system]: true
            }
        })
        this.props.onClickGetVPNClientFile().then(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        }).catch(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        })
    }
    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} variant="light">
                <div onClick={this.props.blockLVPNIsOpen ? this.props.closeBlockLVPN : this.props.openBlockLVPN}
                    style={{ display: "flex", borderBottom: this.props.blockLVPNIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockLVPNIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>  LVPN </div>
                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockLVPNIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>
                </div>
                {
                    this.props.blockLVPNIsOpen ? <div>
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLVPNWinIsOpen ? this.props.closeBlockLVPNWin : this.props.openBlockLVPNWin}
                                style={{ display: "flex", height: this.props.blockLVPNWinIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>  Windows </div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLVPNWinIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>
                            </div>
                            {
                                this.props.blockLVPNWinIsOpen ? <div>

                                    <Table striped style={{ animation: "fadeIn 1s" }}  >

                                        <tbody>
                                            <tr>
                                                <td style={{ width: "55%" }}> LVPN Client </td>
                                                <td style={{ width: "45%" }}>
                                                    <Button
                                                        className="down-btn"
                                                        name="lvpn-client.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.client}
                                                        onClick={e => this.onClickLVPNDownload(e, 'client')}>
                                                        {!this.state.isLoading.client ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "55%" }}> TAP-Windows </td>
                                                <td style={{ width: "45%" }}>

                                                    <Button
                                                        className="down-btn"
                                                        name="tap-windows-9.21.2.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.tap}
                                                        onClick={e => this.onClickLVPNDownload(e, 'tap')}>
                                                        {!this.state.isLoading.tap ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>

                        <div
                            style={{ display: "flex", alignItems: 'center', /*cursor: "pointer"*/ }}>
                            <div style={{ width: "55%" }}>
                                <div style={{ color: "black", }}>VPN клиент файл</div>
                            </div>
                            <div style={{ width: "45%" }}>
                                <div style={{ padding: "0.75rem" }}>
                                    <Button
                                        className="down-btn"
                                        disabled={this.state.isLoading.doc_client}
                                        onClick={() => this.onClickGetVPNClientFile('doc_client')}>
                                        {!this.state.isLoading.doc_client ? "скачать"
                                            :
                                            <Spinner
                                                style={{ width: "1rem", height: "1rem" }}
                                                animation="border"
                                                variant="light"
                                            />
                                        }
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }

            </Alert>
        );
    }
}

export default LVPNBlock;
